<template>
  <div
    :class="['global-loader', { 'global-loader--active': loader.active }]"
  ></div>
</template>

<style lang="scss" scoped>
@keyframes indeterminate {
  0% {
    left: -100%;
  }
  50% {
    left: -50%;
  }
  100% {
    left: 0%;
  }
}

.global-loader {
  display: none;
  position: fixed;
  left: 0;
  top: 0;
  width: 100%;
  height: $global-loader-height;
  overflow: hidden;
  z-index: $global-loader-z;

  &--active {
    display: block;
  }

  &:after {
    content: '';
    position: absolute;
    left: 0;
    top: 0;
    width: 200%;
    height: 100%;
    background-image: linear-gradient(
      to left,
      violet,
      indigo,
      blue,
      green,
      yellow,
      orange,
      red,
      violet,
      indigo,
      blue,
      green,
      yellow,
      orange,
      red
    );
    animation: indeterminate 1.5s linear infinite;
  }
}
</style>

<script>
import { mapState } from 'vuex';

export default {
  computed: {
    ...mapState(['loader'])
  }
};
</script>
